<template>
  <div id="app">
    <!-- Login page - no session gate -->
    <router-view v-if="isLoginPage"/>

    <!-- Main app with session gate -->
    <SessionGate v-else>
      <div class="header">
          <h2>Remittance Advice</h2>
          <div class="user-info" v-if="currentUser">
            <span class="user-name">{{ currentUser.displayName }}</span>
            <button class="logout-btn" @click="handleLogout">Logout</button>
          </div>
      </div>

      <NavigationMenu/>

      <div class="main-content">
          <router-view/>
      </div>
    </SessionGate>
  </div>
</template>

<script>
import NavigationMenu from './components/NavigationMenu.vue'
import SessionGate from './components/SessionGate.vue'
import authService from './services/auth'
import sessionService from './services/session'

export default {
  name: 'app',
  components: {
    NavigationMenu,
    SessionGate
  },
  data() {
    return {
      currentUser: null
    }
  },
  computed: {
    isLoginPage() {
      return this.$route.name === 'Login'
    }
  },
  watch: {
    '$route'() {
      this.updateUserInfo()
    }
  },
  mounted() {
    authService.initialize()
    this.updateUserInfo()

    // Listen for auth errors
    window.addEventListener('auth-error', this.handleAuthError)
  },
  beforeDestroy() {
    window.removeEventListener('auth-error', this.handleAuthError)
  },
  methods: {
    updateUserInfo() {
      this.currentUser = authService.getUser()
    },
    async handleLogout() {
      try {
        // Release session first
        await sessionService.releaseSession()
        // Then logout
        await authService.logout()
      } catch (err) {
        console.error('Logout error:', err)
      } finally {
        this.$router.push({ name: 'Login' })
      }
    },
    handleAuthError() {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style>
    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
    }
    .header {
      position: relative;
    }
    .user-info {
      position: absolute;
      top: 8px;
      right: 16px;
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .user-name {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
    .logout-btn {
      padding: 6px 12px;
      font-size: 12px;
      background: #e74c3c;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.2s;
    }
    .logout-btn:hover {
      background: #c0392b;
    }
    .main-content {
        width: 964px;
        margin: 0 auto;
        border: 0;
        border-radius: 4px;
        justify-content: left;
    }
</style>
